"use strict";

import angular from "angular";

import template from "./data-table.component.html";
import "./data-table.component.scss";

class DataTableController {
    constructor($state) {
        this.$state = $state;
    }
    $onInit() {
        this.exampleStateName = this.$state.current.name;
    }
}

DataTableController.$inject = ["$state"];

const name = "dataTable";
const def = {
    bindings: {
        columns: "<",
        rows: "<"
    },
    template,
    controller: DataTableController
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
